import { injectIntl } from 'react-intl'
import { DifferenceToPayView } from './DifferenceToPayView'

const DifferenceToPayContainer = injectIntl(DifferenceToPayView)

export { DifferenceToPayContainer }
